export default "__VITE_ASSET__BurCY5WO__"